import { render, staticRenderFns } from "./EditBenefit.vue?vue&type=template&id=6df189d6"
import script from "./EditBenefit.js?vue&type=script&lang=js&external"
export * from "./EditBenefit.js?vue&type=script&lang=js&external"
import style0 from "./EditBenefit.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports